<template>
    <div class="loading">
        <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>加载中...</div>
        </Spin>
    </div>
</template>

<script>
import { Spin,Icon } from 'view-design'
import Url from "../utils/url";
import config from "../config/index"
import Request from "../utils/request"
import Base64 from "base-64"
export default {
    components: {Spin,Icon},
    data() {
        return {

        };
    },
    methods: {

    },
    created() {
        let userjid = Url.newGetUrlParam("userJID")
        if(userjid){
            Request.postRequest(config.SXG_baseUrl + "/api/login/getUserRole",{
                Cellphone:Base64.decode(userjid)
            }).then(res=>{
                console.log(res)
                if(res.code == 200){
                    localStorage.setItem("Role",res.data.Center.length ? JSON.stringify(res.data.Center[0]) : JSON.stringify(res.data.Doc[0]))
                    localStorage.setItem("center", res.data.Center.length ? "t" : "f");
                    console.log(this.$route.params.type)
                    if(this.$route.params.type == 1){
                        this.$router.push('/HomePage/DoctorManagement')
                    }else if(this.$route.params.type == 2){
                        this.$router.push('/HomePage/CaseDiscussion/tab_1')
                    }else if(this.$route.params.type == 3){
                        this.$router.push('/HomePage/OperationGuide')
                    }else if(this.$route.params.type == 4){
                        this.$router.push('/HomePage/BaseDoctorPage')
                    }
                }else{
                    this.$Message.error(res.message)
                }
            })
        }
    },
}
</script>
<style lang='less'>
    
</style>